var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { loading } from '../../../elements/Loading';
import Table from '../../../components/Table';
import history from 'helpers/History';
var ExtrasTable = /** @class */ (function (_super) {
    __extends(ExtrasTable, _super);
    function ExtrasTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleSelectItem = function (value) {
            history.push("/extras/".concat(value.id));
        };
        _this.handleCreate = function () {
            history.push('/extras/create');
        };
        return _this;
    }
    ExtrasTable.prototype.render = function () {
        var data = this.props.extras.map(function (value) {
            var temp = value;
            temp.tax = value.tax.name;
            return temp;
        });
        var headers = ['name', 'price', 'tax', 'description'];
        var filters = [
            {
                name: 'actives',
                filter: function (item) { return item.disabled_at === null; }
            },
            {
                name: 'disabled',
                filter: function (item) { return item.disabled_at !== null; }
            },
            {
                name: 'all',
                filter: function (item) { return true; }
            }
        ];
        return (React.createElement(Table, { items: data, header: headers, filters: filters, onSelectItem: this.handleSelectItem, onCreate: this.handleCreate, keyExtractor: function (item) { return String(item.id); } }));
    };
    ExtrasTable = __decorate([
        inject('store'),
        loading(function (props) {
            return [
                props.store.extraStore.read().then(function (extras) { return ({ extras: extras }); })
            ];
        }),
        observer
    ], ExtrasTable);
    return ExtrasTable;
}(Component));
export default ExtrasTable;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Extras/containers/ExtrasTable.tsx
// module id = 1590
// module chunks = 0